'use client';

import { FormEvent, useEffect } from 'react';
import { useRouter, useSearchParams } from 'next/navigation';
import { DiscoveryPageLayout } from '@/domains/paydirt/layout';
import { HaulReportsFeed } from '@/domains/paydirt/layout/HaulReportsFeed';
import { paydirtConfig } from '@/config/paydirt';

function HaulReportsSearchBar({
  initialQuery,
  onSearch,
}: {
  initialQuery: string;
  onSearch: (q: string) => void;
}) {
  function handleSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const data = new FormData(e.currentTarget);
    onSearch(String(data.get('q') ?? '').trim());
  }

  return (
    <form className="paydirt-nav__search haul-reports-search" onSubmit={handleSubmit} role="search">
      <i className="uil uil-search" aria-hidden />
      <input
        type="search"
        name="q"
        defaultValue={initialQuery}
        placeholder="Search haul reports…"
        aria-label="Search haul reports"
      />
      <button type="submit" className="btn btn-secondary btn-sm">
        Search
      </button>
    </form>
  );
}

export function HaulReportsBrowsePage() {
  const router = useRouter();
  const searchParams = useSearchParams();
  const haulConnect = searchParams.get('haulConnect');
  const query = searchParams.get('q') ?? '';
  const userId = searchParams.get('userId') ?? '';

  useEffect(() => {
    if (haulConnect === 'return' || haulConnect === 'refresh') {
      router.replace(`/marketplace/sell/?haulConnect=${haulConnect}`);
    }
  }, [haulConnect, router]);

  if (haulConnect === 'return' || haulConnect === 'refresh') {
    return null;
  }

  function applySearch(q: string) {
    const params = new URLSearchParams();
    if (q) params.set('q', q);
    if (userId) params.set('userId', userId);
    const qs = params.toString();
    router.push(`${paydirtConfig.haulReports.path}${qs ? `?${qs}` : ''}`);
  }

  return (
    <DiscoveryPageLayout
      title={paydirtConfig.haulReports.label}
      description={paydirtConfig.haulReports.description}
      toolbar={<HaulReportsSearchBar initialQuery={query} onSearch={applySearch} />}
    >
      <HaulReportsFeed query={query} userId={userId} showHeading={false} />
    </DiscoveryPageLayout>
  );
}
